import { isOnline, subscribeOnline } from './online'
import type { FlushResult, OfflineQueue, Sender } from './queue'

export interface AutoFlushOptions {
  /** Период повторной попытки, мс (по умолчанию 15 с). */
  intervalMs?: number
  /** Колбэк после каждой попытки (например, invalidate courier/state). */
  onFlushed?: (r: FlushResult) => void
}

/**
 * Авто-отправка очереди: сразу, при событии online, при enqueue (если онлайн) и каждые intervalMs.
 * Возвращает функцию остановки.
 */
export function startAutoFlush(queue: OfflineQueue, sender: Sender, opts: AutoFlushOptions = {}): () => void {
  const interval = opts.intervalMs ?? 15000
  let stopped = false
  let wasOnline = isOnline()

  const tick = () => {
    if (stopped || !isOnline()) return
    queue
      .flush(sender)
      .then((r) => {
        if (!stopped && (r.sent || r.dropped)) opts.onFlushed?.(r)
      })
      .catch((e: unknown) => console.warn('[offline] flush failed', e))
  }

  const offOnline = subscribeOnline(() => {
    const now = isOnline()
    if (now && !wasOnline) tick()
    wasOnline = now
  })
  let lastSize = queue.currentSize
  const offQueue = queue.subscribe((n) => {
    if (n > lastSize) tick()
    lastSize = n
  })
  const timer = setInterval(tick, interval)
  tick()

  return () => {
    stopped = true
    clearInterval(timer)
    offOnline()
    offQueue()
  }
}
